import { apiClient } from './client';
import type { Team } from '../types';

export const teamsApi = {
  list: async () => {
    const res = await apiClient.get('/teams');
    return res.data.data.teams as Team[];
  },

  get: async (id: string) => {
    const res = await apiClient.get(`/teams/${id}`);
    return res.data.data.team as Team;
  },

  create: async (data: { name: string; description?: string; memberIds?: string[] }) => {
    const res = await apiClient.post('/teams', data);
    return res.data.data.team as Team;
  },

  update: async (id: string, data: { name?: string; description?: string; memberIds?: string[] }) => {
    const res = await apiClient.put(`/teams/${id}`, data);
    return res.data.data.team as Team;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/teams/${id}`);
  },
};
